/**
 * 請求・収納API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Szme038aResponseCdtmnyMeisaiInfDto { 
    /**
     * 料金算定期間開始日付：日付(yyyyMMdd)
     */
    calcStartDate?: string;
    /**
     * 料金算定期間終了日付：日付(yyyyMMdd)
     */
    calcEndDate?: string;
    /**
     * 項目名：全半角混在
     */
    itemAname?: string;
    /**
     * 明細情報区分コード：数字<br>　コード変換マスタテーブルの「画面項目ID」\'C021110\'の「ユーザコード」を設定する
     */
    meisaiInfDivcd?: string;
    /**
     * 明細情報区分コード名称：全半角混在
     */
    meisaiInfDivAname?: string;
    /**
     * 明細情報１：数字
     */
    meisaiInf01?: number;
    /**
     * 明細情報２：数字
     */
    meisaiInf02?: number;
    /**
     * 明細情報３：数字
     */
    meisaiInf03?: number;
    /**
     * 明細情報４：数字
     */
    meisaiInf04?: number;
    /**
     * 明細情報５：数字
     */
    meisaiInf05?: number;
    /**
     * 表示単位１：全半角混在
     */
    hyojiUnit01?: string;
    /**
     * 表示単位２：全半角混在
     */
    hyojiUnit02?: string;
    /**
     * 表示単位３：全半角混在
     */
    hyojiUnit03?: string;
    /**
     * 表示単位４：全半角混在
     */
    hyojiUnit04?: string;
    /**
     * 表示単位５：全半角混在
     */
    hyojiUnit05?: string;
    /**
     * 明細情報テキスト１：全半角混在
     */
    meisaiInfText01?: string;
    /**
     * 明細情報テキスト２：全半角混在
     */
    meisaiInfText02?: string;
    /**
     * 明細情報テキスト３：全半角混在
     */
    meisaiInfText03?: string;
    /**
     * 明細情報テキスト４：全半角混在
     */
    meisaiInfText04?: string;
    /**
     * 明細情報テキスト５：全半角混在
     */
    meisaiInfText05?: string;
    /**
     * 明細出力順：数字
     */
    meisaiOutj?: string;
    /**
     * 請求料金請求計上年月：日付(yyyyMM)
     */
    claimCalcYmt?: string;
    /**
     * サービス契約番号：数字
     */
    srvCtrNo?: string;
    /**
     * プロダクトコード：英数字
     */
    prdCode?: string;
    /**
     * 料金計算定義料金コード：英数字
     */
    chargeCode?: string;
    /**
     * 表示内訳コード：英数字
     */
    hyojiDetailCode?: string;
}

